module.exports = __webpack_public_path__ + "img/bg_light@2x.6b518734.png";